<template>
  <v-layout>
  <v-navigation-drawer scrim="rgba(0,0,0,0)" v-model="drawer" location="right" temporary :width="400"
        style="background: white; box-shadow: none;overflow: auto;padding-bottom: 50px;"
        class="side-menu">
        <v-card flat="" style="overflow: auto !important;">
            <div class="d-flex align-center justify-space-between pr-2">
              <v-card-title>Customize Columns</v-card-title>
              <v-icon @click="onClose()">mdi-close</v-icon>
            </div>
            <v-divider></v-divider>
            <div class="contains" :class="customClass(headers)">
              <v-row>
                <v-col cols="12" class="py-0 mt-4">
                  <v-checkbox class="py-0 all" :model-value="allOptionsSelected" label="Select All"
                      color="primary" @click="allSelected()"></v-checkbox>
                </v-col>
                <v-col cols="6" class="py-0" v-for="(item, index) in headers" :key="index">
                    <v-checkbox v-if="item.title != 'Actions'" :model-value="getModel(item.column_required)" class="py-0" :label="item.label"
                        color="primary" @update:model-value="checkSelection(item)"></v-checkbox>
                </v-col>
              </v-row>
            </div>
        </v-card>

    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import moment from "moment";
// import DatamodelDetailsService from "@/api/service/DataModelDetails/DataModelsDetailsService";

export default {
  components: {  },
  props: {
    modelValue: Boolean,
    headers: Array
  },
  data() {
    return {
      drawer: this.modelValue,
      columns: [],
      allOptionsSelected: true,
      defaultColumns:this.headers,
      selectedHeaders: []    // checked items
    };
  },
  watch: {
    modelValue(val) {
      this.drawer = val;
      // if (val) this.columnEditor();
    },
    drawer(val) {
      this.$emit('update:modelValue', val);
    },
    columns(val){
      console.log(val,"ertyuiop")
    }
  },
  methods: {
    moment,
    onClose() {
      this.drawer = false;
    },

    getModel(data) {
        if (data === 1) {
            return true
        } else {
            return false
        }
    },
    async allSelected() {
      this.allOptionsSelected = !this.allOptionsSelected
      this.$emit("allSelected", this.allOptionsSelected);
      
      // this.headers.forEach((column) => {
      //   column.column_required = newValue;
      // });
      // console.log(this.headers,"iiiii")
    },

    checkSelection($item) {
      this.$emit("editColumns", $item);
    },

    customClass(data) {
        if (!data) {
            return '';
        } else if (data.length < 9) {
            return '';
        } else if (data.length < 17) {
            return 'lessThan';
        } else if (data.length < 25) {
            return 'lessThan';
        } else if (data.length < 33) {
            return 'moreThan';
        } else if (data.length < 41) {
            return 'moreThan';
        } else {
            return 'moreMoreThan';
        }
    },
  },
};
</script>


<style scoped>
.text-crimson {
  color: crimson;
}

.textFields {
  margin-top: 24px;
  margin-right: 14px;
}

.table-card {
  border-radius: 12px;
}

>>>.custom-table th:last-child,

>>>.custom-table td:last-child {

  position: sticky !important;
  right: 0 !important;
  z-index: 10 !important;
  min-width: 120px !important;
  /* display: flex;
    align-items: center;
    gap: 12px; */

}

>>>.custom-table tr:nth-child(even) td:last-child {
  background-color: #f6f6ff !important;
}

>>>.custom-table tr:nth-child(odd) td:last-child {
  background-color: #FFFFFF !important;
}

>>>.custom-table tr:nth-child(even) td:last-child:hover {
  background-color: #c9c9ca !important;
  /* transition: background 0.3s !important;     */
}

>>>.custom-table tr:nth-child(odd) td:last-child:hover {
  background-color: #c9c9ca !important;
  /* transition: background 0.3s !important;     */
}


::v-deep(.custom-table thead th) {
  /* min-width: 250px; */
  /* max-width: 500px; */
  background-color: #e2e2fc !important;
  color: #000000 !important;
  font-weight: 600 !important;
  font-size: 18px;
}

::v-deep(.custom-table tbody tr:nth-child(even)) {
  background-color: #f6f6ff;
}

::v-deep(.custom-table tbody tr:hover) {
  background-color: #c9c9ca;
  transition: background 0.3s;
}

::v-deep(.custom-table tbody td) {
  font-weight: 500;
  font-size: 15px;
  /* min-width: 250px; */
  /* max-width: 500px; */
}

.title {
  font-weight: 500;
}

.custom-table td {
  width: 600px;
}
/* .contains {
    display: flex;
    justify-content: center;
} */
</style>